import { generateApiClient } from '@guiker/rest-client'

import { AuthenticatedApi } from '../api-definition'
import { config } from '../config'

export const AuthenticatedApiClient = generateApiClient(config.apiName, AuthenticatedApi.routes)
